import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {EsBsModalService} from "../../services/bsModalService/bs-modal.service";
import {Story} from "../../models/Story/Story";
import {StoryService} from "../../services/storyService/story.service";
import {Slide} from "../../models/Story/Slide";

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnInit {

  public Yiit = Yiit;
  public modalMessage = 'Your browser does not support copying images into clipboard. Would you like to download the image?';
  public stories : Story[] = [];
  private selectedStory: Story = null;
  public selectedStoryName: string;
  public isStoriesAvailable = window['STORIES_ALLOWED'];

  @ViewChild('dropDown', {static: false}) dropDown: ElementRef<HTMLDivElement>;

  constructor(private bsModal: EsBsModalService, private storyAdapter: StoryService) { }

  ngOnInit() {
    this.stories = this.storyAdapter.stories;
    this.updateSelectedStory();
    this.reInitCurrentStory();
    this.storyAdapter.storiesUpdated$.subscribe((stories: Story[])=>{
      this.stories = stories;
      this.updateSelectedStory();
    });
  }
  private reInitCurrentStory(){
    for (let i=0; i < this.storyAdapter.stories.length; i++){
      let story = this.storyAdapter.stories[i];
      if (story.id == this.selectedStory.id){
        this.selectedStory = story;
        break;
      }
    }
  }

  updateSelectedStory(){
    let isStoryNameChanged = this.stories.filter(story => story.name == this.selectedStoryName).length == 0;
    if (this.stories && this.stories.length > 0 && (!this.selectedStory || isStoryNameChanged)) {
      this.selectedStory = this.stories[0];
      this.selectedStoryName = this.selectedStory.name;
    }
  }

  isSelectStoryAvailable(){
    return this.stories && this.stories.length > 1;
  }
  confirmMessage(flag){
      this.bsModal.modalEventFire$ = {'confirm': flag};
  }

  addToStory(event){
    if (!this.selectedStory){
      event.preventDefault();
      event.stopImmediatePropagation();
      event.stopPropagation();
      alert('Select story before adding');
      return;
    }
    let currentSlide = new Slide('slide-'+(this.selectedStory.slides.length+1), this.selectedStory.slides.length+1);
    currentSlide.image = this.storyAdapter.currentImage;
    this.storyAdapter.isScreenshotCreated$ = true;
    this.storyAdapter.addSlideToStory(this.selectedStory, currentSlide);
    this.storyAdapter.currentStory$ = this.selectedStory;
  }

  addToNewStory(event){
    let story = new Story('story-'+(this.storyAdapter.generateStoryCount()), this.storyAdapter.generateStoryId());
    if (!story.id){
      story.id = this.storyAdapter.generateStoryId();
    }
    this.storyAdapter.addStory = story;
    let currentSlide = new Slide('slide-'+(this.selectedStory.slides.length+1), this.selectedStory.slides.length+1);
    currentSlide.image = this.storyAdapter.currentImage;
    this.storyAdapter.isScreenshotCreated$ = true;
    this.storyAdapter.addSlideToStory(story, currentSlide);
    this.storyAdapter.currentStory$ = story;
  }

  createFirstStory(event){
    event.preventDefault();
    this.bsModal.closeModal();
    let story = new Story('story-'+(this.storyAdapter.stories.length+1), this.storyAdapter.stories.length+1);
    if (!story.id){
      story.id = this.storyAdapter.stories.length+1;
    }
    this.storyAdapter.addStory = story;
    this.selectedStory = story;
    let currentSlide = new Slide('slide-'+(this.selectedStory.slides.length+1), this.selectedStory.slides.length+1);
    currentSlide.image = this.storyAdapter.currentImage;
    this.storyAdapter.addSlideToStory(this.selectedStory, currentSlide);
    this.storyAdapter.isScreenshotCreated$ = true;
  }

  getStoryName(story){
    return (story.name && story.name.length > 0) ? story.name : '(no name)';
  }

  selectStory(story){
    this.selectedStory = story;
    this.selectedStoryName = this.selectedStory.name;
    this.storyAdapter.isScreenshotCreated$ = true;
  }

  preventOpenClassOnDropdown():void {
    this.dropDown.nativeElement.classList.remove('open');
  }
}
